
import React from 'react';
import { Redirect } from "react-router-dom";
import { CookieWrap as Cookies } from "../../helper/cookie-wrap";
import { ImgTint } from "../../components/img-tint";
import {objToUrlParam, urlParamToObj} from "../../../lib/url-util";
import './styles.scss';
import '../styles.scss';
import LoginBox from "../login-box";
import { css_file_to_url } from "../../helper/css-util";
import {DISPLAY_LOGIN, DISPLAY_OTP} from "../login-box/login-box";
import { dashboard_url } from "../../helper/dashboard_util";
import {config_to_url} from "../../helper/url";
import {broadcast_message, create_popup_window} from "../../app/popup_window_factory";
import {WINDOW_EVENTS} from "../../app/window_events";
import go_arrow from "../go_button.png";
import {DEVICE_WIDTH} from "../../../lib/constants";

const NEW_ACCOUNT_PATH = "/new_account";
const OFFERINGS_POPUP = "OFFERINGS";

class Login extends React.Component  {

  constructor(props) {
    super(props);
    this.state = {
      credentials:{
        username:'',
        password:''
      },
      error:''
    };
  }

  componentDidMount = () => {
    document.addEventListener("keydown", this.onKeyPressed);

    let params = urlParamToObj(this.props.location.search);

    if (params.userName) {
      let userName = null;
      try {
        userName = decodeURIComponent(params.userName);
      } catch (err) {
        return;
      }

      this.setState({
        credentials: {
          username: userName,
          password: "",
        }
      });
    }

    if (params.table) {
      this.props.navigatePath("/offerings", { table: params.table });
    }
  };

  componentWillUnmount = () => {
    document.removeEventListener("keydown", this.onKeyPressed);
  };

  componentDidUpdate(prevProps) {
    const is_logged_in = !!this.props.token;
    const was_logged_in = !!prevProps.token;
    if (!was_logged_in && is_logged_in) {
      const origin = config_to_url(this.props.config);
      broadcast_message({
        source: WINDOW_EVENTS.CA_APP_LOGIN,
        user: this.props.user,
      }, origin);
    }
  }

  is_small_layout = () => {
    return this.props.app.width <= DEVICE_WIDTH.medium;
  }

  showOfferingsWindow = table => {
    const args = { table };
    const url = "/cds/offerings" + objToUrlParam(args);
    const origin = config_to_url(this.props.app.config);
    this.offeringsWindow = create_popup_window(origin, url, OFFERINGS_POPUP, 1000, 600);
    this.offeringsWindow.addEventListener("message", this.onMessage, false);
  }

  doLogin2 = (email, password) => {
    const username = this.props.wlf_id + "_" + email.trim();
    this.props.twoFAlogin(username, password.trim());
    this.props.clearOnboardingData();
  };

  onKeyPressed = event => {
    if (event.code === 'Escape') {
      this.navToWlfSwitcher();
    }
  };

  navToWlfSwitcher = () => {
    // Remove all wlf/css related cookies
    const cookies = new Cookies();
    cookies.remove('wlf', { path: '/' });
    cookies.remove('wlfid', { path: '/' });
    cookies.remove('wlf_id', { path: '/' });
    this.props.navigatePath("/");
  };

  startInvesting = ev => {
    this.props.navigatePath(NEW_ACCOUNT_PATH)
  };

  render() {
    const {
      token,
      client,
    } = this.props;

    if(!client) {
      return (<Redirect to={{pathname: "/",}}/>);
    }

    const {
      color,
    } = client;

    if(token) {
      let params = urlParamToObj(this.props.location.search);
      const args = {};
      if (params.create_acct_on_login) {
        args.create_acct_on_login = params.create_acct_on_login;
      }
      if (params.purchase_item) {
        args.purchase_item = params.purchase_item;
      }
      const url = dashboard_url(
        this.props.user, this.props.dwolla, this.props.onboarding, this.props.app.wlf,
        -1, args, );
      console.log("login redirect to", url);
      return(
        <Redirect push to={url}/>);
    }

    const offerings = (this.props.app.wlf.ui && this.props.app.wlf.ui.offerings)
      || [];
    const has_offerings = offerings.length > 0;
    const landing_page_url = css_file_to_url(this.props.config, client.landing_page_image);
    const login_style = {
      marginTop: "2rem",
      marginBottom: "0.1rem",
    };

    const container_style = {
        zIndex: "5",
        height: "35rem",
    };
    const is_small = this.is_small_layout();
    const offerings_style = {
      fontSize: is_small ? "2rem" : "4rem",
      fontWeight: "600",
      marginLeft: "2rem",
      cursor: "pointer",
    }
    const offerings_click = () => {
      const args = {table: has_offerings ? offerings[0] : ""}
      this.props.navigatePath("/offerings", args);
    }

    const arrow_style = {
      width: is_small ? "2rem" :"3rem",
      height: is_small ? "2rem" : "3rem",
      transform: "translate(1rem, 0.1rem)",
    }

    const large_div = (
      <div style={{ display: "flex", alignItems: "center"}}>
        <div style={offerings_style} onClick={offerings_click}>
          Current Offerings
          <img src={go_arrow} alt={"arrow"} style={arrow_style}/>
        </div>
      </div>
    )
    const offerings_div = (
      <div style={offerings_style} onClick={offerings_click}>
        Current Offerings
        <img src={go_arrow} alt={"arrow"} style={arrow_style}/>
      </div>);
    //const is_bd = this.props.app.wlf.broker_dealer;

    const display =
      this.props.user.login_state === "OTP" ||
        this.props.user.login_state === "OTP_2"
      ? DISPLAY_OTP : DISPLAY_LOGIN;
    const login_div_style = {
      display: "flex",
    }
    if (is_small) {
      login_div_style.justifyContent = "center";
    }
    const small_off_style = {
      display: "flex",
      margin: "2rem 0",
      justifyContent: "center",
      backgroundColor: "transparent",
    }
    const small_offerings_div = (
      <div style={small_off_style}>
        { offerings_div }
      </div>
    )
    return (
      <div>
        <div className="container-style-responsive" style={container_style}>
          <ImgTint img={landing_page_url} tint={color.top_panel_tint} />
          <div style={login_div_style} id={"loginBoxDiv"}>
            <LoginBox
              path={this.props.location.search}
              style={login_style}
              onLogin={this.doLogin2}
              doingLogin={this.props.isFetching}
              display={display}
              error={this.props.error}/>
            { has_offerings && !is_small && large_div }
          </div>
          { has_offerings && is_small && small_offerings_div }
        </div>
      </div>
    );
  }
}

export default Login;
